import { useEffect, useState } from 'react';
import { SOFTPULL_READY_FAILSAFE_MS } from '~/constants/common/MfeModules';
import useSoftpullMfeReady from './useSoftpullMfeReady';

export default function useSoftpullGatedClick(onClick: () => void) {
  const isReady = useSoftpullMfeReady();
  const [isWaiting, setIsWaiting] = useState(false);

  useEffect(() => {
    if (isReady) {
      setIsWaiting(false);
    }
  }, [isReady]);

  useEffect(() => {
    if (!isWaiting) return undefined;

    const failsafe = setTimeout(
      () => setIsWaiting(false),
      SOFTPULL_READY_FAILSAFE_MS
    );

    return () => clearTimeout(failsafe);
  }, [isWaiting]);

  const handleClick = () => {
    onClick();

    if (!isReady) {
      setIsWaiting(true);
    }
  };

  return { handleClick, isWaiting };
}
